import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: 'systems',
    tagSub: "systems",
    exact: false,
    path: PATHS.SYSTEM.path,
    show: true,
    icon: "setting",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.SYSTEM_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "exchangeRates",
            group: "exchangeRates",
            tagSub: "systems",
            path: PATHS.SYSTEM.EXCHANGE_RATE.path,
            exact: false,
            icon: 'faMoneyBillWave',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.EXCHANGE_RATE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
        },
    ],
}]